import React, { useState } from "react";
import classes from "./RegisterZipGame.module.css";
import Header from "../../components/Header";
import ZipGameStepper from "../../components/ZipGameStepper";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";
import { useTranslation } from "react-i18next";

const RegisterZipGame = () => {
  const navigate = useNavigate();
  const [msisdn, setMsisdn] = useState("");

  const {t}=useTranslation();

  const handleNext = () => {
    if (!msisdn.trim()) return;

    navigate("/verify-otp/zip-game", {
      state: { msisdn },
    });
  };

  return (
    <>
      <Header />

      <div className={classes.container}>

        <div className={classes.header_section}>
          <div className={classes.back_button} onClick={() => {
            navigate("/");
          }}>
            <FaArrowLeft className={classes.back_icon} />
          </div>
        </div>


        <div className={classes.heroCard}>
          <div className={classes.heroBadge}>ZIP GAME</div>
          <h1 className={classes.heroTitle}>{t("278")}</h1>
          <p className={classes.heroText}>
            {t("279")}
          </p>
        </div>

        <ZipGameStepper currentStep={1} />

        <div className={classes.formCard}>
          <div className={classes.section}>
            <div className={classes.sectionHead}>
              <h2 className={classes.sectionTitle}>{t("280")}</h2>
              <p className={classes.sectionText}>
                {t("281")}
              </p>
            </div>

            <div className={classes.inputGroup}>
              <label className={classes.label} htmlFor="msisdn">
                {t("282")}
              </label>

              <div className={classes.phoneField}>
                <div className={classes.countryBox}>
                  <img
                    src="/assets/images/maldives.png"
                    alt="flag"
                    className={classes.flag}
                  />
                  <span className={classes.code}>+960</span>
                </div>

                <input
                  id="msisdn"
                  type="number"
                  className={classes.input}
                  placeholder={t("283")}
                  value={msisdn}
                  onChange={(e) => setMsisdn(e.target.value)}
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            </div>

            <div className={classes.infoBox}>
              <p>
                {t("284")}
              </p>
            </div>

            <button type="button" className={classes.primaryBtn} onClick={handleNext}>
              {t("285")}
            </button>

            {/* here it will be the login option */}
            <p className={classes.link_text}>
              {t("286")}{" "}<span onClick={() => navigate("/login/zip-game")}>{t("287")}</span>
            </p>

          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterZipGame;